import { loadStripe, Stripe } from '@stripe/stripe-js';
import { EmbeddedCheckout, EmbeddedCheckoutProvider } from '@stripe/react-stripe-js';
import { Navigate, useLocation } from 'react-router-dom';
import styles from './checkout.module.scss';

let stripePromise: Promise<Stripe | null> | null = null;

export function getStripePromise() {
  if (!stripePromise) {
    const key = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;
    stripePromise = key ? loadStripe(key) : null;
  }
  return stripePromise;
}

export function Checkout() {
  const location = useLocation();
  const clientSecret = location.state?.clientSecret as string | undefined;
  const stripe = getStripePromise();

  if (!clientSecret || !stripe) {
    return <Navigate to="/onboarding/plan" replace />;
  }

  return (
    <div className={styles.container}>
      <EmbeddedCheckoutProvider stripe={stripe} options={{ clientSecret }}>
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </div>
  );
}
